(function (namespace, $) {
	"use strict";

	var AppMap = function () {
		// Create reference to this instance
		var o = this;
		// Initialize app when document is ready
		$(document).ready(function () {
			o.initialize();
		});
	};

	const customMark = L.Marker.extend({
		options: {
			typeId: "",
		},
	});

	var p = AppMap.prototype;
	p._map = [];
	p._pointsBounds = [];
	p._pointsArea = [];
	p._markerGroup = [];
	p.url = "gpssat";
	p.zoom = 17;
	p.center = [-15.7096, -47.991];

	p.cardsOn = true;
	p.positions = [];
	p.vehicles = [];
	p.timeout = null;

	p.initialize = function () {
		L.Icon.Default.imagePath = "/img/map/";
	};

	p._initializeMap = function (div, menu, plot, height, clusterZoon, fence, loadImplementData, i18n) {
		var o = this;

		var contextmenu = true;
		if (!menu) {
			contextmenu = false;
			menu = [];
		}

		if (!clusterZoon) {
			clusterZoon = 14;
		}

		var osmMap = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
			maxZoom: 20,
			maxNativeZoom: 17,
			attribution: 'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors',
			id: "map.osm",
		});

		var bingMap = new L.BingLayer("mKxMevlnsDBoNxrUdgnT~8PQksJO2gZy1c0Q9tgIkWA~AoMDup6Rdh4fbMZUz3RT-3hd2dNJ7vXGE7th2B5NV0oMvg82REBpNuRu9l-r9rZQ", {
			maxZoom: 20,
			maxNativeZoom: 17,
			type: "AerialWithLabels",
		});

		var esri = L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
			attribution:
				"Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
			maxZoom: 20,
			maxNativeZoom: 17,
		});

		var OpenTopoMap = L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png", {
			maxZoom: 20,
			maxNativeZoom: 17,
			attribution:
				'Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="https://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
			id: "map.topomap",
		});

		var Esri_WorldTopoMap = L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}", {
			maxZoom: 20,
			maxNativeZoom: 17,
			attribution:
				"Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community",
		});

		var baseLayers = {
			"Satélite 1": bingMap,
			"Satélite 2": esri,
			"Topográfico 1": OpenTopoMap,
			"Topográfico 2": Esri_WorldTopoMap,
			Simplificado: osmMap,
		};

		o._map[div] = L.map(div, {
			center: o.center,
			zoom: o.zoom,
			layers: [bingMap],
			fullscreenControl: true,
			contextmenu: contextmenu,
			contextmenuWidth: 200,
			contextmenuItems: menu,
		});
		setTimeout(() => {
			o._map[div].invalidateSize();
		}, 500);
		o._map[div].onRe;
		o._map[div].attributionControl.setPrefix("");

		new L.Control.GeoSearch({
			provider: new L.GeoSearch.Provider.OpenStreetMap(),
		}).addTo(o._map[div]);

		L.control
			.coordinates({
				decimals: 4,
			})
			.addTo(o._map[div]);

		L.control.layers(baseLayers, null, { position: "bottomleft" }).addTo(o._map[div]);
		const { height: viewHeight, paddingTop, paddingBottom } = getComputedStyle(document.querySelector("#content"));
		$(`#${div}`).height(`calc(${viewHeight} - ${paddingTop} - ${paddingBottom} - ${Number.parseInt(height ?? 0)}px)`);

		o._pointsBounds[div] = new L.featureGroup();
		o._pointsBounds[div].addTo(o._map[div]);
		o._pointsArea[div] = new L.featureGroup();
		o._pointsArea[div].addTo(o._map[div]);
		o._markerGroup[div] = L.markerClusterGroup({
			disableClusteringAtZoom: clusterZoon,
		});

		if (plot) {
			o._addButton(
				div,
				"btn-plot",
				{
					stateName: "plot-map",
					icon: "fa-object-ungroup",
					title: Lang.get("form.plots"),
					onClick: function () {
						window.gpssat.AppPage._renderModal(
							window.location.origin + "/treeview/plots",
							"",
							{
								checkPlots: jQuery("[name=treeview-plot-" + div + "]").val(),
								checkActivities: jQuery("[name=activities-" + div + "]").val(),
							},
							"POST",
						);
					},
				},
				"topleft",
			);

			jQuery("#" + div).append("<input type='hidden' name='treeview-plot-" + div + "' value=''/>");
			jQuery("#" + div).append("<input type='hidden' name='activities-" + div + "' value=''/>");
			jQuery("#" + div).append("<input type='hidden' name='plots-" + div + "' value=''/>");
		}

		if (fence) {
			o._addButton(
				div,
				"btn-fence",
				{
					stateName: "plot-fence",
					icon: "fa-object-ungroup",
					title: "Fences",
					onClick: function () {
						window.gpssat.AppPage._renderModal(
							window.location.origin + "/fences/getTreeView",
							"",
							{
								checkedFences: jQuery("[name=treeview-fence-" + div + "]").val(),
								_token: jQuery("[name=csrf-token]").attr("content"),
							},
							"POST",
						);
					},
				},
				"topleft",
			);

			jQuery("#" + div).append("<input type='hidden' name='treeview-fence-" + div + "' value=''/>");
			jQuery("#" + div).append("<input type='hidden' name='fences-" + div + "' value=''/>");
		}

		if (loadImplementData) {
			let pageId = $("#" + div).attr("data-page-id");

			o._addButton(
				div,
				"btn-load-implement-data-map-" + pageId,
				{
					stateName: "load-implement-data",
					icon: "fa-thumb-tack",
					title: i18n.toggle_implement_activations,
				},
				"topleft",
			);
		}

		var measureControl = L.control.measure({
			position: "bottomleft",
			primaryLengthUnit: "kilometers",
			secondaryLengthUnit: "meters",
			primaryAreaUnit: "acres",
			secondaryAreaUnit: "hectares",
			localization: "pt_BR",
		});
		measureControl.addTo(o._map[div]);

		gpssat.App._functions[window.gpssat.AppPage._tabsActionId]["onClose"].push(() => o._destroyMap(div));
		const containerId = o._map[div]._container._leaflet_id;
		o._map[div]._containerId = containerId;
		return this;
	};

	p._addButton = function (mapId, id, states, position) {
		var o = this;
		L.easyButton({
			id: id,
			states: [states],
		})
			.addTo(o._map[mapId])
			.setPosition(position ? position : "topright");
	};

	p._addControlMap = function (div, defaultValue, shapeOptions, layerType = "polygon") {
		var o = this;

		var drawnItems = new L.FeatureGroup();
		o._map[div].addLayer(drawnItems);

		let shapeOptionsDefault = {
			color: "#3388ff",
		};

		var drawControl = new L.Control.Draw({
			position: "topright",
			draw: {
				polyline: {
					shapeOptions: shapeOptions ? shapeOptions : shapeOptionsDefault,
				},
				polygon: {
					shapeOptions: shapeOptions ? shapeOptions : shapeOptionsDefault,
				},
				rectangle: {
					shapeOptions: shapeOptions ? shapeOptions : shapeOptionsDefault,
				},
				circle: false,
				marker: false,
			},
			edit: {
				remove: false,
				featureGroup: drawnItems,
			},
		});
		o._map[div].addControl(drawControl);

		o._map[div].on("draw:created", function (e) {
			var length = 0;
			for (var i in drawnItems._layers) length++;
			if (length > 0) {
				for (var i in drawnItems._layers) {
					drawnItems.removeLayer(drawnItems._layers[i]);
				}
			}
			if (drawnItems._layers.length > 1) {
			}
			drawnItems.addLayer(e.layer);

			if (e.layerType === "polyline") {
				jQuery("#coord-polyline-" + o._getPageId()).val(
					e.layer._latlngs.toString().replace(new RegExp("LatLng\\(", "g"), "").replace(new RegExp("\\)", "g"), "").replace(new RegExp(", ", "g"), " "),
				);
			} else {
				jQuery("#coord-polygon-" + o._getPageId()).val(
					e.layer._latlngs.toString().replace(new RegExp("LatLng\\(", "g"), "").replace(new RegExp("\\)", "g"), "").replace(new RegExp(", ", "g"), " "),
				);
			}

			jQuery("#coord-" + o._getPageId()).val(
				e.layer._latlngs.toString().replace(new RegExp("LatLng\\(", "g"), "").replace(new RegExp("\\)", "g"), "").replace(new RegExp(", ", "g"), " "),
			);
		});

		o._map[div].on("draw:edited", function (e) {
			var layers = e.layers;
			layers.eachLayer(function (layer) {
				jQuery("#coord-" + o._getPageId()).val(
					layer._latlngs.toString().replace(new RegExp("LatLng\\(", "g"), "").replace(new RegExp("\\)", "g"), "").replace(new RegExp(", ", "g"), " "),
				);
			});
		});

		if (defaultValue) {
			let layer = null;

			if (layerType === "polyline") {
				layer = new L.Polyline(defaultValue).setStyle(shapeOptions ? shapeOptions : shapeOptionsDefault);
			} else {
				layer = new L.Polygon(defaultValue).setStyle(shapeOptions ? shapeOptions : shapeOptionsDefault);
			}

			drawnItems.addLayer(layer);
			o._pointsBounds[o._getPageId()].addLayer(layer);
		}
	};

	p._addMarker = function (coord, icon, popup, menu, type) {
		let marker = this._createMarker(coord, icon, popup, menu, type);
		this._pointsBounds[this._getPageId()].addLayer(marker);
		return marker;
	};

	p._createMarker = function (coord, icon, popup, menu, type) {
		var contextmenu = true;
		if (!menu) {
			contextmenu = false;
			menu = [];
		}
		var marker = new customMark(coord, {
			icon: icon,
			typeId: type,
			contextmenu: contextmenu,
			contextmenuWidth: 200,
			contextmenuInheritItems: false,
			contextmenuItems: menu,
		});
		if (popup) {
			marker
				.bindPopup(popup.content, {
					closeOnClick: false,
					closeButton: true,
					autoClose: false,
				})
				.openPopup();
		}
		return marker;
	};

	p._addMarkerGroup = function (coord, icon, popup, menu, type) {
		var o = this;

		var contextmenu = true;
		if (!menu) {
			contextmenu = false;
			menu = [];
		}

		var marker = new customMark(coord, {
			icon: icon,
			typeId: type,
			contextmenu: contextmenu,
			contextmenuWidth: 200,
			contextmenuInheritItems: false,
			contextmenuItems: menu,
		});

		if (popup) {
			marker
				.bindPopup(popup.content, {
					closeOnClick: false,
					closeButton: true,
					autoClose: false,
				})
				.openPopup();
		}

		o._markerGroup[o._getPageId()].addLayer(marker);
		return marker;
	};

	p._addPolyline = function (coords, options) {
		var o = this;

		o._pointsBounds[o._getPageId()].addLayer(new L.polyline(coords, options ? options : {}));

		return this;
	};

	p._addLayer = function (points) {
		var o = this;
		o._pointsBounds[o._getPageId()].addLayer(points);
	};

	p._removeLayer = function (points) {
		var o = this;
		o._pointsBounds[o._getPageId()].removeLayer(points);
	};

	p._addPolylineDecorator = function (coords, options) {
		var o = this;
		const color = options.color ? options.color : '#4396E8';
		var polyline = new L.polyline(coords, options ? options : {});
		o._pointsBounds[o._getPageId()].addLayer(polyline);
		o._pointsBounds[o._getPageId()].addLayer(
			new L.polylineDecorator(polyline, {
				patterns: [
					{
						offset: 25,
						repeat: 100,
						symbol: L.Symbol.arrowHead({
							pixelSize: 10,
							pathOptions: {
								fillOpacity: 1,
								color: color,
								weight: 0
							},

						}),
					},
				],
			}),
		);

		return this;
	};

	p._addPolygon = function (coords, options) {
		var o = this;

		o._pointsBounds[o._getPageId()].addLayer(new L.polygon(coords, options));

		return this;
	};

	p._addArea = function (coords, options, popup, type = "polygon") {
		let o = this;
		let layer = null;

		if (type === "polyline") {
			layer = new L.polyline(coords, options);
		} else {
			layer = new L.polygon(coords, options);
		}

		if (popup) {
			layer.bindPopup(popup.content, { maxWidth: 580 });
		}

		if (type === "polyline") {
			o._pointsBounds[o._getPageId()].addLayer(layer);
		} else {
			o._pointsArea[o._getPageId()].addLayer(layer);
		}

		return this;
	};

	p._addPattern = function (pattern) {
		var o = this;

		o._map[o._getPageId()].addPattern(pattern);

		return this;
	};

	p._adjustBounds = function () {
		var o = this;

		if (typeof o._pointsBounds[o._getPageId()].getBounds() != "undefined") {
			var points = o._pointsBounds[o._getPageId()].getBounds();
			if (points.isValid()) {
				o._map[o._getPageId()].fitBounds(points);
			}
		}
	};

	p._clearArea = function () {
		var o = this;

		o._pointsArea[o._getPageId()].clearLayers();
	};

	p._clearLayers = function (type) {
		var o = this,
			layerGroup = null;

		if (type) {
			var layers = o._pointsBounds[o._getPageId()].getLayers();
			for (var i in layers) {
				layerGroup = layers[i].getLayers();
				for (var l in layerGroup) {
					if (layerGroup[l].options.typeId == type) {
						o._markerGroup[o._getPageId()].removeLayer(layerGroup[l]);
						o._pointsBounds[o._getPageId()].removeLayer(layerGroup[l]);
					}
				}
				if (layers[i].options.typeId == type) {
					o._pointsBounds.removeLayer(layers[i]);
				}
			}
		} else {
			const markers = o._markerGroup[o._getPageId()];
			const points = o._pointsBounds[o._getPageId()];
			if (markers) {
				o._markerGroup[o._getPageId()].clearLayers();
			}
			if (points) {
				o._pointsBounds[o._getPageId()].clearLayers();
			}
		}
	};

	p._resizeMap = function () {
		var o = this;
		o._map[o._getPageId()].invalidateSize();
	};

	p._destroyMap = function (pageIdOverride) {
		const pageId = pageIdOverride ?? this._getPageId();
		const map = this._map[pageId];
		if (map) {
			map.remove();
			delete this._map[pageId];
		}
	};

	p._setPageId = function (id) {
		var o = this;
		o._pageId = id;
	};

	p._getPageId = function () {
		var o = this;
		return "map-" + window.gpssat.AppPage._tabsActionId + (o._pageId ? o._pageId : "");
	};

	p._fitBounds = (container, coordinates) => {
		const foundMap = p._map[container];
		foundMap.fitBounds(coordinates, {
			padding: [50, 50],
			maxZoom: 18,
			animate: true,
			duration: 1.5
		});
	}

	p.getCurrentPageMapId = function () {
		return this._getPageId();
	};

	p.hasMap = function (mapId) {
		const foundMap = this._map[mapId];
		return Boolean(foundMap);
	};

	p.getMap = function (mapId) {
		const mapExists = this.hasMap(mapId);
		return mapExists ? this._map[mapId] : null;
	};

	p.hasCurrentPageMap = function () {
		const defaultPageMapId = this.getCurrentPageMapId();
		return this.hasMap(defaultPageMapId);
	};

	p.getCurrentPageMap = function () {
		const defaultPageMapId = this.getCurrentPageMapId();
		return this.getMap(defaultPageMapId);
	};

	p.createMap = function ({ container = {}, options = {}, i18n = {} }) {
		const { id = this.getCurrentPageMapId(), heightSubtractionFactor = 0 } = container;
		const { menuItems = [], hasPlot = false, hasImplementActivationData = false, disableClusteringAtZoom = 14, hasFence = false } = options;
		return this.getMap(id)
			? this
			: this._initializeMap(id, menuItems, hasPlot, heightSubtractionFactor, disableClusteringAtZoom, hasFence, hasImplementActivationData, i18n);
	};

	p.validateCoordinates = (coordinates) => {
		if (inputIsInvalid(coordinates)) return null;
		const [latitude, longitude] = getFormattedCoordinates(coordinates);
		const isValidCoordinates = isValidCoordinate(latitude, "latitude") && isValidCoordinate(longitude, "longitude");
		return isValidCoordinates ? [latitude, longitude] : null;
		function inputIsInvalid(coordinates) {
			const isNotEmpty = coordinates;
			const isSuportedType = Array.isArray(coordinates) || typeof coordinates === 'string';
			const isValid = isNotEmpty && isSuportedType;
			return !isValid;
		}
		function getFormattedCoordinates(coordinates) {
			const coordinatesArray = Array.isArray(coordinates) ? coordinates : separateCoordinates(coordinates);
			return ensureCoordinatesAreNumbers(coordinatesArray);
			function separateCoordinates(coordinates) {
				const EXPECTED_COORDINATE_SEPARATOR = " ";
				return coordinates.split(EXPECTED_COORDINATE_SEPARATOR);
			}
			function ensureCoordinatesAreNumbers(coordinates) {
				return coordinates.map((coordinate) => Number(coordinate));
			}
		}
		function isValidCoordinate(coordinate, type) {
			const { min, max } = getCoordinateValueLimits(type);
			const isInvalidNumber = Number.isNaN(coordinate);
			if (isInvalidNumber) return false;
			return coordinateRespectedLimits(coordinate, min, max);
			function getCoordinateValueLimits(type) {
				const max = type === "latitude" ? 90 : 180;
				const min = -max;
				return { max, min };
			}
			function coordinateRespectedLimits(formatedCoordinate, min, max) {
				const respectedMin = formatedCoordinate >= min;
				const respectedMax = formatedCoordinate <= max;
				return respectedMin && respectedMax;
			}
		}
	};

	p._setVehicles = function (vehicles) {
		var o = this;
		o.vehicles = vehicles;
		o.positions = [];
		jQuery("#card-map-main").empty();
	};

	p._addCards = function () {
		var o = this;

		if (o.timeout !== null) {
			clearTimeout(o.timeout);
		}

		if (o.vehicles.length > 0 && o.cardsOn) {
			o.timeout = setTimeout(function () {
				o.addCard();
			}, 10000);
		}
	};

	p._showCards = function () {
		var o = this;

		if (o.cardsOn) {
			o.cardsOn = false;
			if (o.timeout !== null) {
				clearTimeout(o.timeout);
			}
			jQuery("#card-map-main").hide();
		} else {
			o.cardsOn = true;
			jQuery("#card-map-main").show();
			o._addCards();
		}
	};

	p._zoomCard = function (vehicleId) {
		var o = this;

		var url = window.location.origin + "/maps/" + vehicleId + "/vehicle/latlon";

		window.gpssat.App._ajax(
			"GET",
			url,
			null,
			function (response) {
				if (response.length && Math.abs(response[0].latlon.split(" ")[0]) < 90) {
					var latlon = response[0].latlon.split(" ");

					if (o._map[o._getPageId()].getZoom() < 12) {
						o._map[o._getPageId()].setView(latlon, 12);
					} else {
						o._map[o._getPageId()].setView(latlon);
					}
				} else {
					alerts._error("Não localizado");
				}
			},
			function (response) { },
			false,
		);
	};

	p.addCard = function () {
		var o = this;

		if (o.cardsOn && jQuery("#card-map-main").length) {
			window.gpssat.App._ajax(
				"POST",
				window.location.origin + "/maps/vehicle/card",
				{
					_token: jQuery("[name=csrf-token]").attr("content"),
					vehicles: o.vehicles,
					positions: o.positions,
				},
				function (response) {
					if (response.position > 0) {
						jQuery("#card-map-main").prepend(response.html);

						o.positions.push(response.position);

						if (jQuery(".map-card-details").length > 10) {
							jQuery(jQuery(".map-card-details").last()).remove();
							o.positions.shift();
						}
					}

					o._addCards();
				},
				function (response) {
					alerts._error("Erro ao buscar notificações");

					o._addCards();
				},
				false,
			);
		} else {
			clearTimeout(o.timeout);
			o.timeout = null;
		}
	};

	p.getEventIconUrl = (vehicleType, eventTypeId) => {
		let iconUrl = '';

		switch (eventTypeId) {
			case 20001: // engine_turn_on
				iconUrl = '/img/map_icons/green/key.png';
				break;
			case 20002: // engine_turn_off
				iconUrl = '/img/map_icons/red/key.png';
				break;
			case 10000: // idle_engine
				iconUrl = '/img/map_icons/yellow/key.png';
				break;
			case 10001: // idle_engine_1
				iconUrl = '/img/map_icons/yellow/key.png';
				break;
			case 10002: // idle_engine_2
				iconUrl = '/img/map_icons/yellow/key.png';
				break;
			case 10003: // idle_engine_3
				iconUrl = '/img/map_icons/yellow/key.png';
				break;
			case 20101: // implement_turn_on
				iconUrl = '/img/map_icons/orange_dot.svg'; // default icon

				if (vehicleType == 'dump_truck') {
					iconUrl = '/img/map_icons/dump_truck_unload_orange.svg';
				}
				break;
			case 2001: // SpeedGPSUp
				iconUrl = '/img/map_icons/red/speed.png';
				break;
		}

		return iconUrl;
	}

	p.getStatusIconDefinitions = (statusDescription) => {
		let iconUrl = '';
		let color = '';

		switch (statusDescription) {
			case 'moving':
				iconUrl = '';
				color = '#ff4dc4';
				break;
			case 'maintenance_stop':
				iconUrl = '';
				color = '#d0d000';
				break;
			case 'disabled':
				iconUrl = '';
				color = '#000000';
				break;
			case 'comunication_fail':
				iconUrl = '';
				color = '#990000';
				break;
			case 'basicPlan':
				iconUrl = '';
				color = '#cce6ff';
				break;
			case 'backup_machine':
				iconUrl = '';
				color = '#E75C16';
				break;
			case 'maintenance_bkp_machine':
				iconUrl = '';
				color = '#953c0e';
				break;
			case 'inoperative':
				iconUrl = '';
				color = '#9b9b9b';
				break;
			case 'supply_tank':
				iconUrl = '';
				color = '#b55b00';
				break;
			case 'supply_vehicle':
				iconUrl = '';
				color = '#f7912a';
				break;
			case 'mechanic_stop':
				iconUrl = '';
				color = '#4d083d';
				break;
			case 'attendance':
				iconUrl = '';
				color = '#43c90e';
				break;
			case 'backOperation':
				iconUrl = '';
				color = '#0066cc';
				break;
			case 'preventive_washing':
				iconUrl = '';
				color = '#644e37';
				break;
			case 'maintenance_scheduled':
				iconUrl = '/img/map_icons/yellow/maintenance.svg';
				color = '#6e4c02';
				break;
			case 'operating':
				iconUrl = '/img/map_icons/green/start.svg';
				color = '#4CAF50';
				break;
			case 'operator_displacement':
				iconUrl = '';
				color = '#4DB6AC';
				break;
			case 'work_shift':
				iconUrl = '';
				color = '#4FC3F7';
				break;
			case 'maintenance_bkp_machine':
				iconUrl = '';
				color = '#953c0e';
				break;
			case 'avaliable':
				iconUrl = '';
				color = '#2196F3';
				break;
			case 'supply':
				iconUrl = '/img/map_icons/orange/supply.svg';
				color = '#FFC107';
				break;
			case 'breakdown':
				iconUrl = '/img/map_icons/red/maintenance.svg';
				color = '#F44336';
				break;
			case 'maintenance':
				iconUrl = '/img/map_icons/brown/maintenance_1.svg';
				color = '#795548';
				break;
			case 'indisponible':
				iconUrl = '';
				color = '#9E9E9E';
				break;
			case 'operating_stop':
				iconUrl = '/img/map_icons/purple/pause.svg';
				color = '#AB47BC';
				break;
			case 'meal':
				iconUrl = '/img/map_icons/pink/stop.svg';
				color = '#EC407A';
				break;
			case 'moving_supply':
				iconUrl = '/img/map_icons/orange/supply.svg';
				color = '#ffc107';
				break;
			case 'awaiting_supply':
				iconUrl = '/img/map_icons/orange/supply.svg';
				color = '#ffc107';
				break;
			case 'maintenance_preventive':
				iconUrl = '/img/map_icons/brown/maintenance_2.svg';
				color = '#8d6e63';
				break;
			case 'off_duty':
				iconUrl = '';
				color = '#009688';
				break;
			default:
				iconUrl = '';
				color = '#FFF';
		}

		return {
			iconUrl: iconUrl,
			color: color
		};
	}

	window.gpssat.AppMap = new AppMap();
})(window.gpssat, jQuery); // pass in (namespace, jQuery):

L.drawLocal = {
	draw: {
		toolbar: {
			// #TODO: this should be reorganized where actions are nested in actions
			// ex: actions.undo  or actions.cancel
			actions: {
				title: "Cancelar desenho",
				text: "Cancelar",
			},
			finish: {
				title: "Finish desenho",
				text: "Concluir",
			},
			undo: {
				title: "Excluir último ponto desenhado",
				text: "Excluir último ponto",
			},
			buttons: {
				polyline: "Desenhar uma polilinha",
				polygon: "Desenhar um polígono",
				rectangle: "Desenhe um retângulo",
				circle: "Desenhar um círculo",
				marker: "Desenhar um marcador",
			},
		},
		handlers: {
			circle: {
				tooltip: {
					start: "Clique e arraste para desenhar círculo.",
				},
				radius: "Raio",
			},
			marker: {
				tooltip: {
					start: "Clique no mapa para colocar marcador.",
				},
			},
			polygon: {
				tooltip: {
					start: "Clique para começar a desenhar a forma.",
					cont: "Clique para continuar a desenhar a forma.",
					end: "Clique primeiro ponto para fechar esta forma.",
				},
			},
			polyline: {
				error: "<strong>Erro:</strong> bordas forma não pode cruzar!",
				tooltip: {
					start: "Clique para iniciar a linha de desenho.",
					cont: "Clique para continuar desenho de linha.",
					end: "Clique último ponto para terminar linha.",
				},
			},
			rectangle: {
				tooltip: {
					start: "Clique e arraste para desenhar um retângulo.",
				},
			},
			simpleshape: {
				tooltip: {
					end: "Solte o mouse para finalizar o desenho.",
				},
			},
		},
	},
	edit: {
		toolbar: {
			actions: {
				save: {
					title: "Salvar alterações.",
					text: "Salvar",
				},
				cancel: {
					title: "Cancelar edição, descarta todas as alterações. ",
					text: "Cancelar",
				},
			},
			buttons: {
				edit: "Editar camadas.",
				editDisabled: "Não há camadas para editar.",
				remove: "Excluir camadas.",
				removeDisabled: "Não há camadas para excluir.",
			},
		},
		handlers: {
			edit: {
				tooltip: {
					text: "Arraste as alças, ou marcador para editar recurso.",
					subtext: "Clique em Cancelar para desfazer as alterações.",
				},
			},
			remove: {
				tooltip: {
					text: "Clique em um recurso para remover",
				},
			},
		},
	},
};
